import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { CAMPAIGN_BANNER_API, CAMPAIGN_PROCESS_API, VERIFY_FARABI_CUSTOMER_API } from '../../../data-access/constants/api';
import { BaseApiService } from '../../../components/core/services/base-api.service';
import { TServiceResult } from '../../../data-access/models/base/t-service-resutl';
import { Transaction } from '../../../data-access/models/transaction.model';
import { TreasureHuntCampaignProcess } from '../../../data-access/models/treasure-hunt.model';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private baseApiService: BaseApiService) {}

  verifyFarabiCustomer(): Observable<TServiceResult<boolean>> {
    const params = new HttpParams();
    return this.baseApiService.get(VERIFY_FARABI_CUSTOMER_API, params).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return of(new TServiceResult<boolean>(false, err.message, err.error, false));
      }),
    );
  }

  getColorAndLabel = function ({ statusName, orderPaymentTypeName }: Transaction) {
    switch (statusName) {
      case 'حذف شده':
      case 'رد سيستم':
      case 'رد مدير':
        return {
          colorVariant: 'danger',
          color: 'red',
          label: orderPaymentTypeName === 'خرید' ? 'خرید ناموفق' : 'فروش ناموفق',
          chipsLabel: orderPaymentTypeName === 'خرید' ? 'خرید ناموفق واحد سرمایه‌گذاری' : 'فروش ناموفق واحد سرمایه‌گذاری',
        };
      case 'پيش نويس':
      case 'انتظار تاييد':
        return {
          colorVariant: 'pending',
          color: 'steel',
          label: orderPaymentTypeName === 'خرید' ? 'درخواست خرید' : 'درخواست فروش',
          chipsLabel:
            orderPaymentTypeName === 'خرید'
              ? 'درخواست خرید واحد سرمایه‌گذاری ممکن است بین ۲ تا ۵ روز کاری طول بکشد.'
              : 'درخواست فروش واحد سرمایه‌گذاری ممکن است بین ۲ تا ۵ روز کاری طول بکشد.',
        };
      case 'تاييد':
        return {
          colorVariant: orderPaymentTypeName === 'خرید' ? 'success' : 'info',
          color: orderPaymentTypeName === 'خرید' ? '#00CC6D' : '#789AFF',
          label: orderPaymentTypeName === 'خرید' ? 'خرید موفق' : 'فروش موفق',
          chipsLabel:
            orderPaymentTypeName === 'خرید' ? ' خرید واحد سرمایه‌گذاری با موفقیت انجام شد.' : 'فروش واحد سرمایه‌گذاری با موفقیت انجام شد',
        };
      default:
        return {
          color: '',
          label: '-',
          chipsLabel: '-',
          colorVariant: 'info',
        };
    }
  };

  getCampaignBanner(): Observable<TServiceResult<{ campaigns: TreasureHuntCampaignProcess[] }>> {
    const params = new HttpParams();
    return this.baseApiService.get(CAMPAIGN_BANNER_API, params).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return of(new TServiceResult<boolean>(false, err.message, err.error, false));
      }),
    );
  }

  getCampaignProcess(
    code: string,
    payload?: string,
    parameters?: any,
  ): Observable<
    TServiceResult<{
      data: {
        pageName: string;
        remainingDays: string;
        prizeAmount: string;
        instrumentDisplaySymbol: string;
        instrumentSymbol: string;
        phoneNumber: string;
        customerProfile: any;
        contractEtfAgreements: any[];
        countdownInSeconds: string;
      };
    }>
  > {
    const params = new HttpParams();
    let url = CAMPAIGN_PROCESS_API + '?campaignCode=' + code;
    if (payload) url += '&' + payload;
    return this.baseApiService.post(url, parameters).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return of(new TServiceResult<boolean>(false, err.message, err.error, false));
      }),
    );
  }
}
